import React from 'react';
import { Box, TextField, Typography } from '@barracuda-internal/bds-core-v2';

type Variant = 'small' | 'medium';

type DescriptionProps = {
  limit: number;
  labelTxt: string;
  variant: Variant;
  value: string;
  setValue: (value: string) => void;
};

function DescriptionInput({limit, labelTxt, variant, value, setValue}: DescriptionProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= limit) {
      setValue(event.target.value);
    }
  };
  const characterCount = value.length;

  return (
    <Box sx={{ display: 'flex', margin: '10px 0px' }}>
      <TextField
        label={labelTxt}
        multiline
        variant="outlined"
        value={value}
        onChange={handleChange}
        size={variant}
        inputProps={{ maxLength: limit }}
        sx={{ width: '40%' }}
      />
      <Typography
        variant="caption"
        sx={{
          marginTop: 'auto',
          marginBottom: '0px',
          fontSize: '10px',
          color: 'gray',
          marginLeft: '5px',
        }}
      >
        {characterCount} / {limit}
      </Typography>
    </Box>
  );
}

export default DescriptionInput;